import { trustItems } from "@/mocks/homeData";

export default function TrustSection() {
  return (
    <section id="trust" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center">
        <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden border border-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20verified%20checkmark%20and%20document%20icons%20on%20soft%20cream%20paper%20background%2C%20clean%20flat%20line%20illustration%2C%20amber%20and%20green%20tones%2C%20calm%20trustworthy%20editorial%20style&width=1000&height=800&seq=91trust-visual&orientation=landscape"
            alt="入口信息核验示意"
            title="91网入口信息来源说明"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute bottom-4 left-4 right-4 bg-background-50/95 backdrop-blur rounded-lg border border-background-200 px-4 py-3">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-verified-badge-line text-lg"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">信息核对优先于速度</p>
                <p className="text-xs text-foreground-600">只整理可核对的官方口径入口</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <span className="text-xs font-medium tracking-wide text-accent-600">可信说明</span>
          <h2 className="mt-2 font-heading font-bold text-xl md:text-3xl text-foreground-950">
            为什么可以放心用这个入口汇总
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本页只做入口指引，目的就是让你少在陌生站点间试错，尽快找到最新可用的地址。
          </p>

          <div className="mt-6 flex flex-col gap-3">
            {trustItems.map((item) => (
              <div
                key={item.id}
                className="flex items-start gap-3 bg-background-50 rounded-lg border border-background-200 px-4 py-3.5"
              >
                <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                <div>
                  <h4 className="font-medium text-sm text-foreground-950">{item.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}